/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import { FileType } from "Api";
import { UUID } from "../Utils/Types";

export enum PathType {
  INPUT = "INPUT",
  OUTPUT = "OUTPUT",
  BOTH = "BOTH",
  NEITHER = "NEITHER",
}

export enum PrimitiveDataType {
  INT32 = "INT32",
  INT64 = "INT64",
  UINT32 = "UINT32",
  UINT64 = "UINT64",
  SINT32 = "SINT32",
  SINT64 = "SINT64",

  FLOAT = "FLOAT",
  DOUBLE = "DOUBLE",

  BOOL = "BOOL",

  STRING = "STRING",
  BYTES = "BYTES",
}

export function extractDataType(sourceLabel: string): PrimitiveDataType {
  if (sourceLabel != undefined || sourceLabel != null) {
    const match = sourceLabel.match(
      /\b(int32|int64|uint32|uint64|sint32|sint64|fixed32|fixed64|sfixed32|sfixed64|float|double|bool|string|bytes)\b/
    );
    if (!match) {
      console.warn(`No primitive type found in: "${sourceLabel}"`);
      return null;
    }

    const typeStr = match[0];
    switch (typeStr) {
      case "int32":
        return PrimitiveDataType.INT32;
      case "int64":
        return PrimitiveDataType.INT64;
      case "uint32":
        return PrimitiveDataType.UINT32;
      case "uint64":
        return PrimitiveDataType.UINT64;
      case "sint32":
        return PrimitiveDataType.SINT32;
      case "sint64":
        return PrimitiveDataType.SINT64;
      case "float":
        return PrimitiveDataType.FLOAT;
      case "double":
        return PrimitiveDataType.DOUBLE;
      case "bool":
        return PrimitiveDataType.BOOL;
      case "string":
        return PrimitiveDataType.STRING;
      case "bytes":
        return PrimitiveDataType.BYTES;
    }
  }
}

export interface PathEntry {
  byString?: string;
  isChild?: boolean;
}

export interface Path {
  nodeDescriptorID: UUID;
  pathType: PathType;
  pathEntries: PathEntry[];
}

export interface Granual {
  id: string;
  label?: string;
  dataType?: PrimitiveDataType;
  sourceFileId?: string; // Track which input file this granual comes from
}

export interface FileInfoPair {
  content: string;
  fileType: FileType;
  fileName: string;
}

export interface Edge {
  sourceID: string;
  sourcePath: Path;
  sourceLabel?: string;
  targetID: string;
  targetPath: Path;
  targetLabel?: string;
}

export interface Mapping {
  transformId: string;
  associatedFileId?: string; // Keep for backward compatibility
  associatedFileIds?: string[]; // Support multiple input files
  granuals?: Granual[];
}
